module.exports = __webpack_public_path__ + "img/icon-kf.fb034532.png";